// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gAst","actions":"styles_actions__1BXfu","error":"styles_error__1GiEA","message":"styles_message__12gSS"};